// extracted by mini-css-extract-plugin
export default {"container":"SuccessPage_container__O5dWe","backgroundVideo":"SuccessPage_backgroundVideo__9DcuS","animation":"SuccessPage_animation__r-rJD","text":"SuccessPage_text__46kfY"};